<script setup lang="ts">
import { Toaster } from 'vue3-hot-toast'
</script>

<template>
  <Toaster
    :toast-options="{
      style: {
        fontWeight: 'bold',
        fontSize: '14px',
      },
      success: {
        style: {
          padding: '4px 6px 4px 12px',
        },
      },
      error: {
        style: {
          padding: '4px 6px 4px 12px',
        },
      },
      blank: {
        style: {
          background: '#def5fc',
          color: '#1a1a1a',
          padding: '4px 6px',
        },
      },
    }"
  />
</template>
